import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { buildAntdTheme } from "./antdTheme";
import {
  DEFAULT_THEME_ID,
  THEMES,
  applyDocumentTheme,
  persistThemeId,
  readStoredThemeId,
} from "./themes";

const ThemeContext = createContext({
  themeId: DEFAULT_THEME_ID,
  theme: THEMES[DEFAULT_THEME_ID],
  antdTheme: buildAntdTheme(THEMES[DEFAULT_THEME_ID]),
  setThemeId: () => {},
});

export function ThemeProvider({ children }) {
  const [themeId, setThemeIdState] = useState(() => {
    const id = readStoredThemeId();
    if (typeof document !== "undefined") applyDocumentTheme(id);
    return id;
  });

  const setThemeId = useCallback((nextId) => {
    const id = THEMES[nextId] ? nextId : DEFAULT_THEME_ID;
    setThemeIdState(id);
    persistThemeId(id);
    applyDocumentTheme(id);
  }, []);

  useEffect(() => {
    applyDocumentTheme(themeId);
  }, [themeId]);

  const value = useMemo(() => {
    const theme = THEMES[themeId] || THEMES[DEFAULT_THEME_ID];
    return {
      themeId: theme.id,
      theme,
      antdTheme: buildAntdTheme(theme),
      setThemeId,
    };
  }, [themeId, setThemeId]);

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
